/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  IconButton,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  SelectChangeEvent,
  TextField,
} from "@mui/material";

import { useNavigate } from "react-router-dom";

import AddCharges from "../../Modals/addChargesModal";
import IosSwitchMain from "../../components/iosSwitchMain";

type OfferTableProps = {
  actionType?: "active" | "scheduled" | "expired" | "quick";
};

const SubscriptionTable = ({ actionType = "quick" }: OfferTableProps) => {
  const navigate = useNavigate();
  const [expandedRowId, setExpandedRowId] = useState<number | null>(null);

  const label = { inputProps: { "aria-label": "Switch demo" } };

  const rows = [
    {
      id: 1,
      name: "Single Membership",

      price: "AED 4,500",
      description:
        "Perfect for a shorter-term commitment with full privileges.",
      created: "2nd-June-2025 | 6:00PM",
      type: "Monthly",
    },
    {
      id: 2,
      name: "Single Membership",
      type: "Monthly",
      price: "AED 4,500",
      description:
        "Perfect for a shorter-term commitment with full privileges.",
      created: "2nd-June-2025 | 6:00PM",
    },
  ];
  let hidden = ["fullName"];

  const toggleExpand = (id: number) => {
    setExpandedRowId((prevId) => (prevId === id ? null : id));
  };
  const [Employee, setEmployee] = React.useState("0");
  const handleChange1 = (event: SelectChangeEvent) => {
    setEmployee(event.target.value as string);
  };
  const [Status, setStatus] = React.useState("0");
  const handleChange2 = (event: SelectChangeEvent) => {
    setStatus(event.target.value as string);
  };
  const [open, setOpen] = useState(false);
  const handleCloseModal = () => {
    setOpen(false);
  };

  return (
    <>
      <div className="table_container">
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th>S.No</th>
              <th>Name</th>
              <th>Description</th>
              <th>Type</th>
              <th>Price</th>

              <th>Created At</th>
              <th>Status</th>

              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <React.Fragment key={row.id}>
                <tr>
                  <td>{row.id}</td>
                  <td
                    className="cursor_p max_c2"
                    onClick={() => navigate("/manage-subscription/view")}
                  >
                    {" "}
                    <p> {row.name}</p>
                  </td>
                  <td className="max_c2">
                    {" "}
                    <p> {row.description}</p>{" "}
                  </td>
                  <td>{row.type}</td>

                  <td>{row.price}</td>
                  <td>{row.created}</td>
                  <td>
                    <IosSwitchMain />
                  </td>

                  <td>
                    <div className="table_actions v2">
                      <IconButton
                        className="toggle_btn text_btn"
                        onClick={() => toggleExpand(row.id)}
                      >
                        <img src="/static/images/edit_icon.svg" alt="user" />
                      </IconButton>
                      <IconButton
                        className="toggle_btn text_btn"
                        onClick={() => toggleExpand(row.id)}
                      >
                        <img src="/static/images/delete_icon.svg" alt="user" />
                      </IconButton>
                    </div>
                  </td>
                </tr>
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
      <AddCharges open={open} onClose={handleCloseModal} setOpen={setOpen} />
    </>
  );
};

export default SubscriptionTable;
